export const resumeThemes = [
  'even',
  'modern',
  'macchiato',
  'msresume',
  'react',
  'rickosborne',
  'rnord',
  'sceptile',
  'straightforward',
  'theme_class',
] as const;

export const resumeThemesNew = [
  'basic',
  'caffeine',
  'echo',
  'frostline',
  'meadow',
  'react',
  'straightforward',
] as const;

export const aiResumeStrictnessConst = ['strict', 'moderate', 'loose'] as const;

export type ResumeTheme = (typeof resumeThemes)[number];
export type ResumeThemeNew = (typeof resumeThemesNew)[number];
export type AiResumeStrictness = (typeof aiResumeStrictnessConst)[number];
